import { render } from "./PayExpress.vue?vue&type=template&id=73b60212"
import script from "./PayExpress.vue?vue&type=script&lang=js"
export * from "./PayExpress.vue?vue&type=script&lang=js"

import "./PayExpress.vue?vue&type=style&index=0&id=73b60212&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__